import {CancelTokenSource} from "axios";
import {appApi} from "@services/api.service";
import {GoogleMapsDistance, GoogleMapsLocation} from "@models/google/googleMaps";

const endpointPrefix = 'google-maps';

const getLocations = async (query: string, sessionToken: string, cancelToken?: CancelTokenSource): Promise<GoogleMapsLocation[]> => {
    const response: any = await appApi.get(`${endpointPrefix}/search-locations`, {
        params: {
            query,
            sessionToken,
        },
        cancelToken: cancelToken?.token
    });

    return response.data;
}

const getDistance = async (startingPlace: string, destinationPlace: string, waypoints?: string[], cancelToken?: CancelTokenSource): Promise<GoogleMapsDistance> => {
    let jsonWaypoints = '';
    if (waypoints && waypoints.length > 0) {
        jsonWaypoints = JSON.stringify(waypoints);
    }

    const response: any = await appApi.get(`${endpointPrefix}/calculate-distance`, {
        params: {
            startingPlace,
            destinationPlace,
            waypoints: jsonWaypoints,
        },
        cancelToken: cancelToken?.token
    });

    return response.data;
}

export {
    getLocations,
    getDistance,

};